import { render, staticRenderFns } from "./goodsManage.vue?vue&type=template&id=40738f52&scoped=true&"
import script from "./goodsManage.vue?vue&type=script&lang=ts&"
export * from "./goodsManage.vue?vue&type=script&lang=ts&"
import style0 from "./goodsManage.vue?vue&type=style&index=0&id=40738f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40738f52",
  null
  
)

export default component.exports